const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/bookmarks.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { loadMobileBookmarksContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
export const Route = createFileRoute("/_protected/bookmarks")({
  loader: preloadMobilePage(loadMobileBookmarksContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});